import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class ExamsService {

  exams = [];
  constructor(private http: HttpClient) {
    this.exams = [];
    console.log('Jobs initialized!!', this.exams);
  }

  addExamInJob(data) {
    console.log('Adding MARKS', data);
    let array = { learners: data }
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.post(config.baseApiUrl + "exam/AddMarks", array).subscribe((res: any) => {
        observer.next(res.data);
        // observer.complete();
      }, err => {
        console.log("ERROR");
        observer.error(err.msg);
      }, () => {
        observer.complete()
      })
    })
  }

  getExamMarks(jobId) {
    console.log("Getting MARKS");
    return new Observable<any>((observer) => {
      console.log("Observable");
      this.http.get(config.baseApiUrl + "exam?jobId=" + jobId ).subscribe((res: any) => {
        console.log("response marks : ", res.data);
        observer.next(res.data);
        observer.complete();
      })
    });
  }
}
